/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import DataGrid from 'components/DataGrid';
import LoadingScreen from 'components/LoadingScreen';
import { useAtomValue } from 'jotai';
import React, { Suspense } from 'react';

import { membersDataAtom } from './state';
import { useSubscriptionModalDataConfig } from './SubscriptionModalDataGrid.config';

const SubscriptionModalDataGrid = ({
  subscriptions,
  isBulk = false,
}: {
  subscriptions: any;
  isBulk?: boolean;
}) => {
  const { config, data } = useSubscriptionModalDataConfig(
    subscriptions,
    isBulk,
  );
  const membersDataLoading = useAtomValue(membersDataAtom).loading;
  const loading = !isBulk ? membersDataLoading : false;

  return (
    <Suspense fallback={<LoadingScreen />}>
      <DataGrid config={config} data={data} loading={loading} />
    </Suspense>
  );
};

export default SubscriptionModalDataGrid;
